<template>
  <div>
    <common :dataSource='dataSource' :type="2" surveyNoPrefix="Teacher-"></common>
  </div>
</template>
<script>
import common from './common.vue'
export default {
  components: {
    common
  },
  methods: {

  },
  data() {
    return {
      dataSource: [
        [
          {
            type: 5,
          },
          {
            type: 3,
            title: '以下是教师课堂教学行为的描述，请根据您的实际情况做出判断并点击对应的选项。'
          },
          {
            type: 2,
            headline: '1.在我的课上，学生有机会交流他们的看法和观点。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '2.当学生提出某些观点时，我鼓励他们进一步思考之后才表明我的态度。 ',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '3.我能深入细致地了解学生的建议，让他们感受到我很认真地对待他们。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '4.学生在我的课上经常进行小组活动。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '5.我为学生提供机会让他们了解彼此的优缺点。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '6.我赞赏学生将所学知识派上不同的用场。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '7.我给学生布置有待他们自己解决的问题。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '8.我鼓励学生为教学出谋划策。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '9.我鼓励学生从不同的角度思考，哪怕其想法可能行不通。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '10.学生知道我不会轻易否定他们的建议。',
            value: [
              '从不这样', '很少这样', '有时这样', '经常这样', '总是这样'
            ]
          },
          {
            type: 2,
            headline: '11.我鼓励学生用课上所学的知识做不同的事情。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '12.我帮助学生从他们的失败中吸取教训。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '13.我教给学生基础知识并给他们留出个人自学的时间。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '14.我只在学生充分讨论他们的看法后才发表评论。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '15.我喜欢学生花时间从不同的方面进行思考。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '16.无论对错我的学生都有机会自己进行判断。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '17.即便学生的建议并不实际或不一定有用，我也会认真对待。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '18.我不介意学生偏离我所教的内容去尝试自己的想法。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '19.我鼓励遭受挫折的学生把挫折看作学习的一部分。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '20.我给学生布置开放性的问题，让他们自己去寻求答案。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '21.我期望学生在小组活动中主动合作。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '22.尽管以不同的方式做事要占用更多的时间，我还是鼓励学生这么做。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '23.我耐心倾听学生提出的幼稚可笑的问题。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
          {
            type: 2,
            headline: '24.我鼓励遭遇失败的学生寻求其他可能的解决办法。',
            value: [ '从不这样', '很少这样', '有时这样', '经常这样', '总是这样' ]
          },
        ],
        [
          {
            type: 3,
            title: '以下题目是关于教师教学观念的描述，请根据您的理解做出判断并点击对应的选项。'
          },
          {
            type: 2,
            headline: '1.您认为下面哪种表述是合理的？',
            value: [
              '所有孩子都有相同程度的创造性', '某些孩子更有创造性'
            ]
          },
          {
            type: 6,
            headline: '2.您认为下面哪些问题能激发创造性？（可多选）',
            value: [
              '开放的', '封闭的', '只有唯一正确答案的', '有多种答案的', '明确定义的', '非明确定义的', '学生不熟悉的', '学生以前遇到过的', '与学生先前知识相关的', '与学生先前知识无关或较少相关的'
            ],
            answerList: []
          },
          {
            type: 2,
            headline: '3.创新型学生可以在多个领域用多种方式表现其创造性。',
            value: [
              '同意', '不同意'
            ]
          },
          {
            type: 2,
            headline: '4.您认为教师遇到有创造性学生的频率。',
            value: [
              '总是', '经常', '有时', '很少'
            ]
          },
          {
            type: 2,
            headline: '5.优秀学生比普通学生更有可能具有创造性。',
            value: [
              '同意', '不同意'
            ]
          },
          {
            type: 2,
            headline: '6.当一个人在某一领域有很高的知识水平时，那么这个人在该领域工作时，就很难有创造性。',
            value: [
              '同意', '不同意'
            ]
          },
          {
            type: 2,
            headline: '7.创造力是所有人的特征。',
            value: [
              '同意', '不同意'
            ]
          },
          {
            type: 2,
            headline: '8.创造性思维与学校里解决问题所需的思维不同吗？',
            value: [
              '是', '否'
            ]
          },
          {
            type: 2,
            headline: '9.创造性思维与解决生活中的问题所需的思维不同吗？',
            value: [
              '是', '否'
            ]
          },
          {
            type: 2,
            headline: '10.你认为一个非常聪明的人有可能没有创造力吗？',
            value: [
              '是', '否'
            ]
          },
          {
            type: 6,
            headline: '11.您认为下列哪些说法正确？（可多选）',
            value: [
              '创造性成果对个人和社会来说都是新颖的', '创造性成果对个人和同龄人群体来说是新颖的', '创造性成果对个人来说是新颖的', '创造性成果不一定是新颖的'
            ],
            answerList: []
          },
          {
            type: 2,
            headline: '12.一个孩子自己发现了如何使用回形针。您认为这个孩子有创造力吗？',
            value: [
              '是', '否'
            ]
          },
          {
            type: 2,
            headline: '13.是否有人在历史领域体现出创造力？',
            value: [
              '是', '否'
            ]
          },
          {
            type: 4,
            title: '14.你是否同意以下说法？',
            value: [
              {
                type: 2,
                headline: '（1）创造力可以在每个人身上得到促进。',
                value: [
                  '是', '否', '不清楚'
                ]
              },
              {
                type: 2,
                headline: '（2）只有那些天生具有创造力的人，才能促进创造力的发展。',
                value: [
                  '是', '否', '不清楚'
                ]
              },
              {
                type: 2,
                headline: '（3）创造力是与生俱来的，它不可能被促进。',
                value: [
                  '是', '否', '不清楚'
                ]
              }
            ]
          },
          {
            type: 2,
            headline: '15.学术成就是创造力的一个相对较好的指标。',
            value: [
              '是', '否'
            ]
          },
          {
            type: 6,
            headline: '16.人们表现其创造力的程度取决于（可多选）',
            value: [
              '环境', '知识', '领域', '个性', '任务', '智力'
            ],
            answerList: []
          },
          {
            type: 2,
            headline: '17.一个孩子发现了一种新的三位数加法的方法，但这个策略并没有带来正确的结果，您认为他有创造性吗？',
            value: [
              '有', '无'
            ]
          },
          {
            type: 2,
            headline: '18.学生们在学校里有很多机会体现他们的创造力。',
            value: [
              '同意', '不同意'
            ]
          },
        ],
        [
          {
            type: 3,
            title: '您认为高创造性学生的必需特征和能力是：'
          },
          {
            type: 2,
            headline: '1.需要赞美和强化',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '2.自主性 ',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '3.智力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '4.想象',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '5.愿意接受指导',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '6.易冲动',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '7.服从规则和期望',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '8.有设立自己目标的能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '9.有设立自己规则的能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '10.天生的才能',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '11.独立性',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '12.急躁易怒',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '13.自信心',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '14.担心失败',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '15.兴趣广泛',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '16.批判思维能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '17.类比推理能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '18.情绪化',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '19.艺术倾向',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '20.发散思维能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '21.聚合思维能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '22.发现问题能力',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '23.需要认可和接受',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '24.不守规则',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '25.需要避免错误',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '26.过于自信',
            value: [
              '是', '否', '不清楚'
            ]
          },
          {
            type: 2,
            headline: '27.爱幻想',
            value: [
              '是', '否', '不清楚'
            ]
          },
        ],
        [
          {
            type: 3,
            title: '您认为教师以下哪些行为对于提升学生创造力是必要的？请根据您的理解做出判断并点击对应的选项。'
          },
          {
            type: 2,
            headline: '1.经常开展测评评价：',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '2.重视知识的获取',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '3.强调内在动机',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '4.运用外在奖励',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '5.经常的表扬',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '6.强调自主和独立',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '7.强调竞争',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '8.强调合作学习',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '9.经常详细的反馈',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '10.强调发现学习',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '11.对理论和假设提出质疑的机会 ',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '12.强调遵循指示',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '13.改正错误的机会',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '14.布置选择性作业',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '15.定期布置探究性作业',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '16.定期组织课外实践类活动',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '17.强调测评排名',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '18.测评内容强调能力与素养',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '19.测评内容侧重知识的记忆',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '20.强调多元化的测评方式',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '21.测评设计开放性试题',
            value: [ '是', '否', '不清楚' ]
          },
          {
            type: 2,
            headline: '22.测评设计情境化试题',
            value: [ '是', '否', '不清楚' ]
          },
        ],
        [
          {
            type: 3,
            title: '教师基本信息情况'
          },
          {
            type: 2,
            headline: '1.您的性别：',
            value: [ '男', '女' ]
          },
          {
            type: 2,
            headline: '2.您的年龄：',
            value: [ '35岁及以下', '36—45岁', '46岁及以上' ]
          },
          {
            type: 2,
            headline: '3.您所教的学科',
            value: [ '小学科学', '物理', '化学', '生物', '通用技术', '综合实践' ]
          },
          {
            type: 2,
            headline: '4.您最终的学历：',
            value: [ '中专及以下', '大专', '本科', '研究生' ]
          },
          {
            type: 2,
            headline: '5.您毕业时（第一次参加工作前）所学的专业与目前所教的学科：',
            value: [ '一致', '不一致', '中师或高中毕业，没有特定专业' ]
          },
          {
            type: 2,
            headline: '6.到本学期期末，您学科教学的年限约为：',
            value: [ '2年及以下', '2—5（含）年', '5—10（含）年', '10—15（含）年', '15年以上' ]
          },
          {
            type: 2,
            headline: '7.您目前的职称：',
            value: [ '实习阶段', '小学二级', '小学一级', '小学高级', '中学二级', '中学一级', '中学高级', '正高级教师' ]
          },
          {
            type: 2,
            headline: '8.您是否为科学学科骨干教师？（如果是多种骨干，请选择最高级别）',
            value: [ '不是骨干教师', '校级骨干教师', '区级骨干教师', '市级骨干教师' ]
          },
          {
            type: 2,
            headline: '9.您是否科学学科带头人？（如果是多种带头人，请选择最高级别）',
            value: [ '不是学科带头人', '校级学科带头人', '区级学科带头人', '市级学科带头人' ]
          },
        ]
      ]
    }
  },
}
</script>
<style lang="less">
</style>
